import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchMe } from "../../lib/api";

const AdminContext = createContext({ user: null, loading: true });

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    fetchMe()
      .then(u => setUser(u))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  return (
    <AdminContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdminAuth() { return useContext(AdminContext); }

export function ProtectedAdminRoute({ children }) {
  const { user, loading } = useAdminAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user || user.role !== "admin") navigate("/admin/login");
  }, [user, loading, navigate]);
  if (loading) {
    return <div className="min-h-screen grid place-items-center"><div className="h-8 w-8 border-4 border-[#37B160] border-t-transparent rounded-full animate-spin" /></div>;
  }
  if (!user || user.role !== "admin") return null;
  return children;
}
